module.exports = __webpack_public_path__ + "img/p4-c2-p3.3e4d2f14.jpg";